module.exports = __webpack_public_path__ + "static/livestreaming-6-4ff46c46a0d8fe052e9cec00e62b673b.png";